export class AccountStatementType {
    ID: number;
    Code: string;
    Name: string;
    Inactive?: boolean;
    FullName?: string;
}

export default AccountStatementType;